export default __webpack_public_path__ + "static/media/Image2.91a80a88.png";